import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  editProduct,
  getAllProducts,
} from "../redux/slices/product/productSlice";
import EditorContainer from "../editor/Editor";
import EditorReactFlow from "../flowchart/ReactFlow";
//MaterialUI
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import Icon from "@material-ui/core/Icon";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IProduct from "../../models/product";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getAllSteps } from "../redux/slices/step/stepSlice";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1),
    Width: "100%",
  },
}));

export default function ProductEdit() {
  const dispatch = useDispatch();
  const { slug } = useParams<any>();

  useEffect(() => {
    dispatch(getAllProducts());
  }, [dispatch]);

  const Products: IProduct[] = useSelector((state) => state.product.data);
  const filteredArray: any = Products.find((product) => product.slug === slug);
  const steps = useSelector((state) => state.step.data);
  const combined = { steps, filteredArray };
  useEffect(() => dispatch(getAllSteps(filteredArray.id)), [
    dispatch,
    filteredArray.id,
  ]);

  // console.log(filteredArray); //Current issue here: form loads before data is retrieved from database - 17/03/2021

  const [formData, updateFormData] = useState(filteredArray);

  const handleChange = (e) => {
    const selected = e.target.name;
    updateFormData({
      ...formData,
      [selected]: e.target.value.trim(),
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(editProduct(formData));
  };

  const classes = useStyles();
  if (!filteredArray || filteredArray.length === 0) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  } else {
    return (
      <Container maxWidth="xl">
        <CssBaseline />
        <div className={classes.paper}> </div>
        <div className="{classes.heroContent}">
          <Container maxWidth="sm">
            <form>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="name"
                label="Name"
                name="name"
                autoComplete="name"
                autoFocus
                value={formData.name}
                onChange={handleChange}
              />

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="number"
                label="Number"
                name="number"
                autoComplete="number"
                value={formData.number}
                autoFocus
                onChange={handleChange}
              />

              <FormControl
                variant="outlined"
                required
                fullWidth
                margin="normal"
                id="status"
                className={classes.formControl}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={handleChange}
                  value={formData.status}
                  label="Status"
                  name="status"
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={"active"}>Active</MenuItem>
                  <MenuItem value={"discontinued"}>Discontinued</MenuItem>
                  <MenuItem value={"phase out"}>Phase out</MenuItem>
                </Select>
              </FormControl>

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="description"
                label="description"
                type="description"
                id="description"
                autoComplete="current-description"
                value={formData.description}
                onChange={handleChange}
              />

              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                endIcon={<Icon>send</Icon>}
                onClick={handleSubmit}
              >
                Accept edits
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                startIcon={<DeleteIcon />}
              >
                Cancel
              </Button>
            </form>
          </Container>
          <EditorReactFlow props={combined} />
          <EditorContainer props={combined} />
        </div>
      </Container>
    );
  }
}
